import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import CredentialsBanner from "@/components/landing/CredentialsBanner";
import Services from "@/components/landing/Services";
import Process from "@/components/landing/Process";
import WhyUs from "@/components/landing/WhyUs";
import Pricing from "@/components/landing/Pricing";
import TechStack from "@/components/landing/TechStack";
import FAQ from "@/components/landing/FAQ";
import Footer from "@/components/landing/Footer";

const Index = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;

    const id = location.hash.slice(1);
    const scrollToSection = () => {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    };

    const frame = window.requestAnimationFrame(() => {
      window.requestAnimationFrame(scrollToSection);
    });

    return () => window.cancelAnimationFrame(frame);
  }, [location.hash]);

  return (
    <main className="min-h-screen bg-background">
      <Navbar />
      <Hero />
      <CredentialsBanner />
      <Services />
      <WhyUs />
      <Process />
      <Pricing />
      <TechStack />
      <FAQ />
      <Footer />
    </main>
  );
};

export default Index;
